import HipaaLogo from '@assets/hipaa-logo.svg?react';
import { Box } from '@mui/material';

/**
 * Displays security compliance badges (HIPAA, HITRUST)
 * Shows our commitment to healthcare data security standards
 */
export const ComplianceBadges = () => {
  return (
    <Box sx={{ display: 'flex', gap: 5, justifyContent: 'center' }}>
      <HipaaLogo height={43} fill="#C8ADE1" aria-label="HIPAA Compliant" />
    </Box>
  );
};
